import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Models } from '@ibexfusion/models';

import 'brace/index';
import 'brace/mode/json';
import 'brace/theme/monokai';
import 'brace/theme/solarized_light';
import 'brace/mode/scss';
import 'brace/mode/sass';
import 'brace/mode/html';
import 'brace/mode/css';
import 'brace/mode/handlebars';
import 'brace/ext/language_tools.js';
import 'brace/ext/searchbox.js';

declare const ace: any;

@Component({
    selector: 'code-area',
    templateUrl: './code-area.component.html',
    styleUrls: ['./code-area.component.scss'],
    standalone: false
})
export class CodeAreaComponent implements OnInit {

  @ViewChild('aceEditor', { static: true }) editorElement: ElementRef;

  @Input() value: any;

  @Input() type: string;

  @Input() parent: Models.IbexBaseModel;
  @Input() key: string;
  @Input() readOnly: boolean;
  @Input() isString: boolean;
  @Input() title: string;
  @Input() options: any;

  editor: any;

  fontSize = 16;

  themeDark = true;

  isFolded = false;

  constructor() {
  }

  ngOnInit() {
    if (!this.options) {
      this.options = { maxLines: 45, minLines: 30, fontSize: this.fontSize + 'px', autoScrollEditorIntoView: true };
    }
    if (!this.title) {
      this.title = this.type;
    }
    if (!this.isString) {
      this.value = JSON.stringify(this.value, null, '  ');
    }
    this.editor = ace.edit(this.editorElement.nativeElement);
    this.editor.getSession().setMode('ace/mode/' + this.type);
    this.editor.getSession().setTabSize(2);
    this.editor.setOptions(this.options);
    this.editor.commands.removeCommand('find');
    if (this.value !== null && this.value !== undefined) {
      // do net set a value for a new snippet
      setTimeout(() => {
        // ace editor needs a moment to be ready!
        this.editor.setValue(typeof this.value === 'object' ? JSON.stringify(this.value) : this.value);
        this.editor.clearSelection();
        if (this.type === 'json') {
          this.editor.getSession().foldAll(2);
          this.isFolded = true;
        }
      }, 10);
    }
    if (this.readOnly) {
      this.editor.setReadOnly(true);
      this.themeDark = false;
      this.editor.setTheme('ace/theme/solarized_light');
    } else {
      this.editor.setTheme('ace/theme/monokai');
      this.editor.focus();
      this.editor.on('change', (e) => {
        this.changeValue(e);
      });
    }
  }

  public increaseFont() {
    this.fontSize = this.fontSize + 2;
    if (this.fontSize > 26) {
      return;
    }
    this.editor.setOptions({ fontSize: this.fontSize + 'px' });
  }

  public decreaseFont() {
    this.fontSize = this.fontSize - 2;
    if (this.fontSize < 8) {
      return;
    }
    this.editor.setOptions({ fontSize: this.fontSize + 'px' });
  }

  public changeTheme() {
    if (this.themeDark) {
      this.editor.setTheme('ace/theme/solarized_light');
    } else {
      this.editor.setTheme('ace/theme/monokai');
    }
    this.themeDark = !this.themeDark;
  }

  changeValue(event) {
    if (!this.isString && this.type === 'json') {
      try {
        this.parent[this.key] = JSON.parse(this.editor.getValue());
      } catch (err) {
        console.log(err);
      }
    } else {
      this.parent[this.key] = this.editor.getValue();
    }
  }

  changeFold() {
    if (this.isFolded) {
      this.editor.getSession().unfold();
    } else {
      this.editor.getSession().foldAll(2);
    }
    this.isFolded = !this.isFolded;
  }
}

// todo mark scss errors after save

// https://www.npmjs.com/package/react-ace-tmp
// this.editor.getSession().setAnnotations([{
//   row: 1,
//   column: 0,
//   text: 'Error Message', // Or the Json reply from the parser
//   type: 'error' // also warning and information
// }]);
